export default __webpack_public_path__ + "f423048bf942a7a33b33b1b982ecdb51.png";